/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useCallback } from "react";
import { Link, useParams, useHistory } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  FormGroup,
  Card,
  CardBody,
  Spinner,
  Button,
  Label,
  FormText,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
} from "reactstrap";

import { useForm } from "react-hook-form";

import { yupResolver } from "@hookform/resolvers/yup";

// Toast
import toastr from "toastr";
import "toastr/build/toastr.min.css";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import CustomFormRepeaterRecursive from "../../components/Common/CustomFormRepeaterRecursive";

//i18n
import { withTranslation } from "react-i18next";

import { useDispatch, useSelector } from "react-redux";

import Select from "react-select";

import schema from "./TabValidation.js";

import {
  getTab,
  createTab,
  editTab,
  resetTab,
  resetTabs,
  resetError,
  deleteTab,
} from "../../store/tabs/actions";

const NewTab = ({ t }) => {
  let { idTab } = useParams();
  const dispatch = useDispatch();
  const history = useHistory();
  const { register, handleSubmit, errors, setValue } = useForm({
    resolver: yupResolver(schema),
  });

  const {
    dataTabGetSet,
    dataTabEditCreate,
    loadingTab,
    loadingTabEditCreate,
    successTab,
    errorTab,
    loadingTabDelete,
    dataTabDelete,
  } = useSelector((state) => state.Tab);

  const [newFields, setNewFields] = useState({});
  const [enableSubmit, setEnableSubmit] = useState(false);
  const [elementObject, setElement] = useState({});
  const [modal, setModal] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const [isInformative, setIsInformative] = useState(false);

  const toggleModal = () => {
    setModal(!modal);
  };

  const [tabValues, setTabValues] = useState({
    tabs: {
      name: "",
      children: [],
      skill_id: [],
      global: true,
      hidden: false,
      hidden_operator: false,
      friendlyName: "",
      isInformationTab: false,
    },
    tabsBk: { name: "", children: [], skill_id: [], global: true },
  });

  const showToast = useCallback(
    (type, message) => {
      toastr[type](message);
    },
    [successTab]
  );
  toastr.options = {
    closeButton: false,
    debug: false,
    newestOnTop: false,
    progressBar: true,
    positionClass: "toast-top-right",
    preventDuplicates: true,
    onclick: null,
    showDuration: "200",
    hideDuration: "200",
    timeOut: "2000",
    extendedTimeOut: "2000",
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "fadeIn",
    hideMethod: "fadeOut",
    onHidden: () => successTab && dispatch(resetError()),
  };

  const handleCreateEditTab = () => {
    let aux = newFields?.tabs;
    if (!aux?.skill_id) {
      aux.skill_id = [];
    }
    aux = {
      ...aux,
      children: aux?.children?.map((tab2)=>({
        ...tab2,
        isInformationTab: aux?.isInformationTab,    
        children: tab2?.children?.map((tab3)=>({
          ...tab3,
          isInformationTab: aux?.isInformationTab,
        })) ?? []   
      })) ?? []
    }

    if (idTab) {
      dispatch(editTab(idTab, aux));
    } else {
      dispatch(createTab(aux));
    }
  };

  const newTabSubmit = () => {
    handleCreateEditTab();
  };

  const handleSetIsDefault = () => {
    setTabValues({
      ...tabValues,
      tabs: {
        ...tabValues.tabs,
        isInformationTab: false,
      },
    });
    setIsInformative(false);
  };

  const handleSetIsInformative = () => {
    setTabValues({
      ...tabValues,
      tabs: {
        ...tabValues.tabs,
        isInformationTab: true,
      },
    });
    setIsInformative(true);
  };

  const checkTab = (values, valuesBk) => {
    if (JSON.stringify(values) === JSON.stringify(valuesBk)) {
      delete newFields.tabs;
      checkSubmit();
    } else {
      const removeIdNull = (tab) => {
        let { id, ...rest } = tab;
        return {
          ...rest,
          children:
            rest?.children?.map((e) => {
              let { id, ...rest } = e;
              return {
                ...rest,
                children:
                  rest?.children?.map((e) => {
                    let { id, ...rest } = e;
                    return { ...rest };
                  }) ?? [],
              };
            }) ?? [],
        };
      };

      const objRemovedIdNull = removeIdNull(values);

      if (idTab) {
        setNewFields({
          ...newFields,
          tabs: values,
        });
      } else {
        setNewFields({
          ...newFields,
          tabs: objRemovedIdNull,
        });
      }
    }
  };

  const checkSubmit = () => {
    if (Object.keys(newFields).length > 0) setEnableSubmit(true);
    else setEnableSubmit(false);
  };

  const handleDelete = (e) => {
    if (typeof e.id == "string") dispatch(deleteTab(e.id));

    if (e.posicao === 1) {
      handleChange({
        ...tabValues.tabs,
        children: tabValues.tabs.children.filter((item) => item.id !== e.id),
      });
    } else if (e.posicao === 2) {
      handleChange({
        ...tabValues.tabs,
        children: tabValues.tabs.children.map((element) => ({
          ...element,
          children: element?.children?.filter((item) => item.id !== e.id),
        })),
      });
    }
  };

  const handleChange = (e) => {
    setTabValues({
      ...tabValues,
      tabs: e,
    });
  };

  const optionsSkills = () => {
    let skills = [];

    if (dataTabGetSet?.data?.form?.skills?.length > 0) {
      dataTabGetSet.data.form.skills.map((skill) =>
        skills.push({
          key: skill.id,
          value: skill.id,
          label: skill.name,
        })
      );
    } else {
      if (loadingTabEditCreate) {
        skills.push({
          value: "loading",
          label: t("Loading..."),
          isDisabled: true,
        });
      } else {
        skills.push({
          value: "empty",
          label: t("No matching records found"),
          isDisabled: true,
        });
      }
    }
    return skills;
  };

  useEffect(() => {
    if (idTab) {
      dispatch(getTab(idTab, true));
    } else {
      dispatch(getTab(null, true));
    }
  }, []);

  useEffect(() => {
    if (idTab && dataTabGetSet?.data?.data && !loadingTab) {

      setIsInformative(dataTabGetSet.data.data?.isInformationTab);
      setTabValues({
        tabs: dataTabGetSet.data.data,
        tabsBk: dataTabGetSet.data.data,
      });
    }
  }, [dataTabGetSet]);

  useEffect(() => {
    if (successTab) {
      if (dataTabEditCreate?.message) {
        showToast("success", t(dataTabEditCreate.message));
        dispatch(resetTab());
        dispatch(resetTabs());
        history.push("/tabs");
      }

      if (dataTabDelete?.message) {
        showToast("success", t(dataTabDelete.message));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [successTab]);

  useEffect(() => {
    if (errorTab && typeof errorTab === "object") {
      errorTab.map((error) => showToast("error", t(error.value)));
      dispatch(resetError());
    } else {
      if (errorTab) {
        showToast("error", t(errorTab));
        dispatch(resetError());
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorTab]);

  useEffect(() => {
    checkSubmit();
  }, [newFields, errors]);

  useEffect(() => {
    setValue("tab", tabValues.tabs, {
      shouldValidate: true,
    });
    checkTab(tabValues.tabs, tabValues.tabsBk);
  }, [tabValues]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            mainPath="/tabs"
            path={"/tab"}
            title={t("Tabs")}
            breadcrumbItem={idTab ? t("Edit Tab") : t("Create tab")}
          />
          <Row>
            <Col xs="12" className="customContent">
              <Card>
                <CardBody>
                  <form onSubmit={handleSubmit(newTabSubmit)}>
                    <Row className="mb-3">
                      <Col md="12">
                        <Row>
                          <Col md="12">
                            <Col md="12">
                              <Row>
                                <p>
                                  {" "}
                                  <i className="bx bx-info-circle" />{" "}
                                  {t("Tab type")}:
                                </p>
                              </Row>
                              <Row className="mb-3">
                                <Button
                                  type="button"
                                  color="primary"
                                  outline={isInformative}
                                  onClick={handleSetIsDefault}
                                >
                                  <i className="bx bx-table" /> {t("Default")}
                                </Button>
                                <Button
                                  className="ml-2"
                                  type="button"
                                  color="primary"
                                  outline={!isInformative}
                                  onClick={handleSetIsInformative}
                                >
                                  <i className="bx bx-info-square" />{" "}
                                  {t("Informative")}
                                </Button>
                              </Row>
                            </Col>
                            <FormGroup>
                              <Label id="tab-name-label">
                                {t("Name") + " *"}
                              </Label>
                              <CustomFormRepeaterRecursive
                                register={() => register({ name: "tab" })}
                                addButtonText={t("Add sublevel")}
                                placeholder={t("Enter tab name")}
                                value={tabValues.tabs}
                                onDelete={(e, pos) => {
                                  e.posicao = pos;
                                  setElement(e);
                                  toggleModal();
                                }}
                                onChange={handleChange}
                              />
                              <div className="invalid-feedback d-block">
                                {t(errors?.tab?.name?.message)}{" "}
                                {errors?.tab?.children?.length > 0 &&
                                  errors.tab.children.map(
                                    (element) => t(element?.name?.message) + " "
                                  )}
                                {errors?.tab?.children?.length > 0 &&
                                  errors.tab.children.map(
                                    (element) =>
                                      element?.children?.length > 0 &&
                                      element?.children.map(
                                        (element) =>
                                          t(element?.name?.message) + " "
                                      )
                                  )}
                              </div>
                            </FormGroup>
                            <FormGroup className="select2-container">
                              <Select
                                ref={() => register({ name: "skill_id" })}
                                classNamePrefix="select2-selection"
                                placeholder={t("Select") + "..."}
                                title={t("Clients")}
                                options={optionsSkills()}
                                onChange={(e) => {
                                  setTabValues({
                                    ...tabValues,
                                    tabs: {
                                      ...tabValues.tabs,
                                      global: false,
                                      skill_id: e
                                        ? e.map((item) => item.value)
                                        : [],
                                    },
                                  });
                                }}
                                value={optionsSkills().filter((element) =>
                                  tabValues?.tabs?.skill_id?.includes(
                                    element.value
                                  )
                                )}
                                isDisabled={tabValues?.tabs?.global}
                                isMulti
                              />
                              <FormText className="mt-3">
                                {t(
                                  "Select the skills of the tab or enable global mode so that the tab is displayed for all skills. To select the skills first disable the global mode"
                                )}
                              </FormText>
                              <div className="d-flex justify-content-between w-100 mt-3">
                                <div
                                  ref={() => register({ name: "global" })}
                                  className="custom-control custom-checkbox"
                                >
                                  <input
                                    type="checkbox"
                                    className="custom-control-input"
                                    checked={tabValues?.tabs?.global}
                                  />
                                  <label
                                    className="custom-control-label"
                                    onClick={() => {
                                      setTabValues({
                                        ...tabValues,
                                        tabs: {
                                          ...tabValues.tabs,
                                          global: !tabValues.tabs.global,
                                          skill_id: [],
                                        },
                                      });
                                    }}
                                  >
                                    {t("Global")}
                                  </label>
                                </div>
                              </div>
                              <div className="invalid-feedback d-block">
                                {t(errors?.tab?.global?.message)}{" "}
                                {t(errors?.tab?.skill_id?.message)}
                              </div>
                            </FormGroup>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <Link to="/tabs">
                      <Button
                        type="button"
                        color="primary"
                        outline
                        onClick={() => dispatch(resetTab())}
                      >
                        {t("Cancel")}
                      </Button>
                    </Link>
                    <Button
                      type="button"
                      color="primary"
                      className="ml-2 waves-effect waves-light"
                      style={{
                        minWidth: "100px",
                      }}
                      onClick={() => setConfirmModal(true)}
                    >
                      {t("Save")}
                    </Button>
                  </form>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Modal isOpen={modal || loadingTabDelete}>
            <div className="modal-body font-size-18 text-center">
              {t("Do you want to delete the tab")}
              <strong> {elementObject.name}</strong>?
            </div>
            <div className="modal-footer">
              <button
                type="button"
                onClick={toggleModal}
                className="btn btn-danger waves-effect"
                data-dismiss="modal"
                style={{ backgroundColor: "#f14646" }}
              >
                {t("No")}
              </button>
              {loadingTabDelete ? (
                <button
                  type="button"
                  className="btn btn-secondary waves-effect waves-light"
                  disabled
                >
                  <Spinner size="sm" animation="border" />
                </button>
              ) : (
                <button
                  type="button"
                  className="btn btn-secondary waves-effect waves-light"
                  onClick={() => {
                    toggleModal();
                    handleDelete(elementObject);
                  }}
                >
                  {t("Yes")}
                </button>
              )}
            </div>
          </Modal>

          <Modal isOpen={confirmModal} toggle={() => setConfirmModal(false)}>
            <ModalHeader>{t("Almost there ...")}</ModalHeader>
            <ModalBody>
              {isInformative
                ? t(
                    "The informational tab will not be available for use in conversations. When used, it will only classify the ticket and not direct it to any automation. If necessary, you can change this setting at another time. Do you want to confirm ?"
                  )
                : t(
                    "Standard type tabs, when used for tickets, will cause the ticket to be routed to an automation. If necessary, you can change this setting at another time. Do you want to confirm ?"
                  )}
            </ModalBody>
            <ModalFooter>
              <Button
                color="primary"
                outline
                onClick={() => setConfirmModal(false)}
              >
                {t("Cancel")}
              </Button>
              <Button
                type="button"
                color="primary"
                className="ml-2 waves-effect waves-light"
                style={{
                  minWidth: "100px",
                  cursor: newFields?.tabs?.name ? "pointer" : "no-drop",
                }}
                onClick={() => handleCreateEditTab()}
                disabled={!newFields?.tabs?.name}
              >
                {loadingTabEditCreate ? (
                  <Spinner
                    size="sm"
                    animation="border"
                    style={{
                      height: "19px",
                      width: "19px",
                    }}
                  />
                ) : (
                  t("Save")
                )}
              </Button>
            </ModalFooter>
          </Modal>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(NewTab);
